export default "__VITE_ASSET__01453647__"